import { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSearchParamsOfBooking } from "../../hooks/searchParams/useSearchParamsOfBooking";
import { useBookingDispatch } from "../../hooks/useBookingState";
import { useProductDetail } from "../../hooks/useProductDetail";
export const useProductDetailPageData = ({
  bookingId,
  editBookingId,
}: {
  bookingId?: string;
  editBookingId?: string;
}) => {
  const { id: slug } = useParams<{ id: string }>();
  const { productData, isLoading, isError, bookingData } = useProductDetail(
    slug!,
    {
      bookingId: bookingId || editBookingId,
      loadLocal: !!bookingId,
    },
  );
  return {
    productData,
    bookingData,
    isLoading,
    isError,
  };
};

export const useProductDetailPage = () => {
  const { bookingId, editBookingId } = useSearchParamsOfBooking();

  const bookingDispatch = useBookingDispatch({
    mode: "FORM",
  });
  const { productData, isLoading, isError, bookingData } =
    useProductDetailPageData({
      bookingId,
      editBookingId,
    });

  const isEdit = useMemo(
    () => !!bookingId || !!editBookingId,
    [bookingId, editBookingId],
  );
  const [scrollToEditArea, setScrollToEditArea] = useState(false);
  useEffect(
    function () {
      if (scrollToEditArea)
        document.getElementById("section-tab-select-option")?.click?.();
    },
    [scrollToEditArea],
  );

  useEffect(
    function () {
      if (isEdit && bookingData && productData) {
        setScrollToEditArea(true);
      }
    },
    [isEdit, bookingData, productData, editBookingId],
  );

  useEffect(function () {
    console.log("===== clear booking");
    bookingDispatch.clear();
  }, []);
  useEffect(
    function () {
      bookingDispatch.init(productData, bookingData);
    },
    [productData, bookingData, bookingDispatch],
  );

  return {
    productData,
    bookingData,
    isLoading,
    isError,
  };
};
